// extracted by mini-css-extract-plugin
module.exports = {"generalYogaPage":"GeneralYogaPage_generalYogaPage__Nq0_K","certifiedInstructors":"GeneralYogaPage_certifiedInstructors__OQX9j"};